import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-route',
  template: ' <div>TEST ROUTE</div> ',
})
export class TestRouteComponent implements OnInit {
  ngOnInit(): void {
    console.log(localStorage.getItem('okta-token-storage'));
  }
}
